/**
 * 订单明细
 */
import React, { FC, useEffect, useState } from 'react'
import './index.scss'

interface IProps {
  dashed?: boolean;
  style?: any;
  type?: string;
  title: string | React.ReactNode;
  content?: any;
  onMore?: (data?: any) => void;
}

const DetailItem: FC<IProps> = ({ style = {}, dashed = false, type = '', title, content, onMore }) => {
  return (
    <>
      {dashed && <div className='dashed'></div>}
      <div className={`detail-item space-between ${type}`} style={style}>
        <div>
          <span className='title'>{title}</span>
          {!!onMore && <i className='iconfont icon-question1' data-cypid='result-show-express' onClick={onMore}></i>}
        </div>
        {!!content && <span className='content'>{content}</span>}
      </div>
    </>
  )
}

export default DetailItem
